import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const AutomaticLogout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const lastActivity = localStorage.getItem("loginTime");
    const currentTime = new Date().getTime();

    const allowedRoutes = [
      "/auth/register/marketer",
      "/auth/register/fulfillment",
      "/auth/register/seller",
      "/auth/register/choice",
      "auth/password/reset",
      "/fulfillment",
      "/ar",
      "/en",
      "/ar/fulfillment",
      "/en/fulfillment",
      "/ar/thank-you",
      "/en/thank-you",
      "/ar/payment-and-delivery-options",
      "/en/payment-and-delivery-options",
      "/ar/privacy-policy",
      "/en/privacy-policy",
      "/ar/return-and-exchange-policy",
      "/en/return-and-exchange-policy",
    ];

    if (allowedRoutes.some((route) => location.pathname.includes(route))) {
      return;
    }

    if (
      !token ||
      (lastActivity && currentTime - parseInt(lastActivity, 10) > 43200000)
    ) {
      localStorage.clear();
      navigate("/ar", { replace: true });
    }
  }, [token]);

  return <>{children}</>;
};

export default AutomaticLogout;
